// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGInfoIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  // flex: "0 0 auto",
  cursor: "pointer",
  display: "block",
};

export default class SVGInfoIcon extends PureComponent<ISVGInfoIconProps, {}> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <g id="Layer_2">
          <g>
            <path
              d="M17.5,1.5c8.822,0,16,7.178,16,16s-7.178,16-16,16s-16-7.178-16-16S8.678,1.5,17.5,1.5 M17.5,0
			C7.835,0,0,7.835,0,17.5S7.835,35,17.5,35S35,27.165,35,17.5S27.165,0,17.5,0L17.5,0z"
            />
          </g>
        </g>
        <g id="Layer_3">
          <circle cx="19.083" cy="9.167" r="2.25" />
          <path
            d="M14.078,14.75l-0.047,0.75c0,0,1.135-0.041,1.344,0.292s0.333-0.001-0.125,1.583s-2.542,8.292-2.542,8.292
		s-0.208,1.167,0,1.667s0.708,1.097,2.458,1.166c2.125,0.084,4.167-2.959,4.583-4.125c0,0-0.284-0.301-0.656-0.047
		c-0.245,0.167-0.515,0.658-0.875,1.078c-0.587,0.685-1.359,1.063-1.578,0.859c-0.188-0.175,4.047-12.156,3.656-12.25
		C20.139,13.978,14.078,14.75,14.078,14.75z"
          />
        </g>
      </svg>
    );
  }
}
